import { FaDeezer, FaSpotify } from 'react-icons/fa6';
import { SiApplemusic } from 'react-icons/si';

export const COMITTEE_MEMBERS = {
  Présidence: [
    {
      pic: '/images/comittee/noe.jpg',
      name: 'Noé Boehringer',
      email: 'noe.boehringer@artiphys.ch',
      role: 'Co-président',
    },
    {
      pic: '/images/comittee/clelia.jpg',
      name: 'Clélia Albert',
      email: 'clelia.albert@artiphys.ch',
      role: 'Co-président',
    },
    {
      pic: '/images/comittee/hanna.jpg',
      name: 'Hanna Zwygart',
      email: 'hanna.zwygart@artiphys.ch',
      role: 'Trésorière',
    },
  ],

  'Vice-présidence': [
    {
      pic: '/images/comittee/gloria.jpg',
      name: 'Gloria De Pontac',
      email: 'gloria.depontac@artiphys.ch',
      role: 'Communications',
    },
    {
      pic: '/images/comittee/adrian.jpg',
      name: 'Adrián Fernández',
      email: 'adrian.fernandezlojo@artiphys.ch',
      role: 'Logistique',
    },
    {
      pic: '/images/comittee/dara.jpg',
      name: 'Dara Goodale',
      email: 'dara.goodale@artiphys.ch',
      role: 'Animations',
    },
  ],

  Responsables: [
    {
      pic: '/images/comittee/rosalie.jpg',
      name: 'Rosalie Lehnherr',
      email: 'rosalie.lehnherr@artiphys.ch',
      role: 'Prog & Loges',
    },
    {
      pic: '/images/comittee/hortense.jpg',
      name: 'Hortense Liaras',
      email: 'hortenseliaras@artiphys.ch',
      role: 'Prog & Loges',
    },
    {
      pic: '/images/comittee/bastien.jpg',
      name: 'Bastien Gaussent',
      email: 'bastien.gaussent@artiphys.ch', // added email
      role: 'Sponsoring',
    },
    {
      pic: '/images/comittee/romain.jpg',
      name: 'Romain Dufour',
      email: 'romain.dufour@artiphys.ch', // added email
      role: 'Sponsoring',
    },
    {
      pic: '/images/comittee/leo.jpg',
      name: 'Léo Haeni',
      email: 'leo.haeni@artiphys.ch',
      role: 'Site & Sécurité',
    },

    {
      pic: '/images/comittee/lucas.jpg',
      name: 'Lucas Shang',
      email: 'lucas.shang@artiphys.ch',
      role: 'Matériel et Transports',
    },
    {
      pic: '/images/comittee/maxime.jpg',
      name: 'Maxime Fanti',
      email: 'maxime.fanti@artiphys.ch',
      role: 'Bars',
    },
    {
      pic: '/images/comittee/ahmed.jpg',
      name: 'Ahmed Elalamy',
      email: 'ahmed.elalamy@artiphys.ch',
      role: 'Bars',
    },
    {
      pic: '/images/comittee/xavi.jpg',
      name: 'Xavi Fuentes',
      email: 'xavi.fuentes@artiphys.ch', // added email
      role: 'Catering',
    },
    {
      pic: '/images/comittee/pernelle.jpg',
      name: 'Pernelle Paget',
      email: 'pernelle.paget@artiphys.ch', // added email
      role: 'Catering',
    },
    {
      pic: '/images/comittee/laetitia.jpg',
      name: 'Laetitia Espinosa',
      email: 'laetitia.espinosa@artiphys.ch',
      role: 'Promotions',
    },
    {
      pic: '/images/comittee/johanne.jpg',
      name: 'Johanne Pinel',
      email: 'johanne.pinel@artiphys.ch', // added email
      role: 'Graphisme',
    },
    {
      pic: '/images/comittee/arthur.jpg',
      name: 'Arthur Taieb',
      email: 'arthur.taieb@artiphys.ch', // added email
      role: 'Tech & Elec',
    },
    {
      pic: '/images/comittee/chloe.jpg',
      name: 'Chloé Cartier',
      email: 'chloe.cartier@artiphys.ch', // added email
      role: 'Tech & Elec',
    },
    {
      pic: '/images/comittee/tim.jpg',
      name: 'Tim Lücking',
      email: 'tim.lucking@artiphys.ch', // added email
      role: 'Décorations',
    },
    {
      pic: '/images/comittee/ambre.jpg',
      name: 'Ambre Sassi',
      email: 'ambre.sassi@artiphys.ch', // added email
      role: 'Décorations',
    },
    {
      pic: '/images/comittee/nina.jpg',
      name: 'Nina Bodenstab',
      email: 'nina.bodenstab@artiphys.ch', // added email
      role: 'Prévention & Durabilité',
    },
    {
      pic: '/images/comittee/clara.jpg',
      name: 'Clara Gottardo',
      email: 'clara.gottardo@artiphys.ch', // added email
      role: 'Ressources Humaines',
    },
    {
      pic: '/images/comittee/maena.jpg',
      name: 'Maena Chavanne',
      email: 'maena.chavanne@artiphys.ch', // added email
      role: 'Innovations & Concepts',
    },
    {
      pic: '/images/comittee/mateo.jpg',
      name: 'Mateo Tiedra',
      email: 'mateo.tiedra@artiphys.ch',
      role: 'Webmaster',
    },
    {
      pic: '/images/comittee/jeremy.jpg',
      name: 'Jeremy Serillon',
      email: 'jeremy.serillon@artiphys.ch', // added email
      role: 'Audiovisuel',
    },
    {
      pic: '/images/comittee/alice.jpg',
      name: 'Alice Savona',
      email: 'alice.savona@artiphys.ch', // added email
      role: 'Artivieilles',
    },
    {
      pic: '/images/comittee/theo.jpg',
      name: 'Théo Altherr',
      email: 'theo.altherr@artiphys.ch', // added email
      role: 'Artivieilles',
    },
  ],
};

export const PAST_EVENTS = [
  {
    poster: '/images/posters/artiphys25.png',
    title: 'Artiphys 2025',
    galleryUrl:
      'https://drive.google.com/drive/folders/1QZziX4hfTU9djd6675P05JyGh4T4omfk',
    artists: [
      {
        name: 'NHŪ',
        url: 'https://www.instagram.com/nothing_nhu/',
      },
      {
        name: 'Herr Krank',
        url: 'https://www.instagram.com/herr.krank/',
      },
      {
        name: 'MZA',
        url: 'https://www.instagram.com/mza.mp3/',
      },
      {
        name: 'Bass Tong',
        url: 'https://www.instagram.com/bass.tong/',
      },
      {
        name: 'Agolino',
        url: 'https://www.instagram.com/loucagolino/',
      },
      {
        name: 'Dean Watt',
        url: 'https://www.instagram.com/deanwatt_/',
      },
      {
        name: 'THAUF',
        url: 'https://www.instagram.com/thauf.music/',
      },
      {
        name: 'Lait et Sukr',
        url: 'https://www.instagram.com/laitetsukr/',
      },
      {
        name: 'Kiftif',
        url: 'https://www.instagram.com/kif.tif/',
      },
      {
        name: 'Redfunktion',
        url: 'https://www.instagram.com/redfunktion303/',
      },
      {
        name: 'Holivia Mermaid',
        url: 'https://www.instagram.com/holivia.ps/',
      },
      {
        name: 'Ashley Balmain',
        url: 'https://www.instagram.com/ashleybarbiana/',
      },
    ],
  },
  {
    poster: '/images/posters/artiboule24.png',
    title: 'Artiboule',
    artists: [
      {
        name: 'LÜMM',
        url: 'https://www.instagram.com/lumm.love/',
      },
      {
        name: 'B3LO',
        url: 'https://www.instagram.com/owbelo/',
      },
      {
        name: 'DJ NOKAP',
        url: 'https://www.instagram.com/p4k_0/',
      },
      {
        name: 'Collectif alps',
        url: 'https://www.instagram.com/collectifalps/',
      },
      {
        name: 'Dean Watt',
        url: 'https://www.instagram.com/deanwatt_/',
      },
      {
        name: 'Agolino',
        url: 'https://www.instagram.com/loucagolino/',
      },
      {
        name: 'Enji le fils',
        url: 'https://www.instagram.com/enjilefils/',
      },
    ],
  },
  {
    poster: '/images/posters/prelude24.png',
    title: 'Prelude',
    artists: [
      {
        name: 'Paranoise',
        url: 'https://www.instagram.com/paranoise.system/',
      },
    ],
  },
  {
    poster: '/images/posters/artiphys24.png',
    title: 'Artiphys 2024',
    artists: [
      {
        name: 'Calling Marian',
        url: 'https://www.instagram.com/callingmarian/',
      },
      {
        name: 'Durdenhauer',
        url: 'https://www.instagram.com/durdenhauer/',
      },
      {
        name: 'Meyem',
        url: 'https://www.instagram.com/meyem_lt/',
      },
      {
        name: 'Desire',
        url: 'https://www.instagram.com/julie_desire_/',
      },
      {
        name: 'Disse',
        url: 'https://www.instagram.com/disse2620/',
      },
      {
        name: 'Entelechia',
        url: 'https://www.instagram.com/entelechia____/',
      },
      {
        name: 'Nothan Solo',
        url: 'https://www.instagram.com/nothansolo_/',
      },
      {
        name: 'E-garbage',
        url: 'https://www.instagram.com/e_garbage_/',
      },
      {
        name: 'Jabrome',
        url: 'https://www.instagram.com/jabrome.jpg/',
      },
      {
        name: 'Nahomi',
        url: 'https://www.instagram.com/nahomi.music/',
      },
      {
        name: 'Monica Creampie',
        url: 'https://www.instagram.com/monicacreampie/',
      },
    ],
  },
];

export const PLAYLISTS = [
  {
    platform: 'Spotify',
    icon: FaSpotify,
    url: 'https://open.spotify.com/playlist/2YqOHVRiNXruOVKvNDhjLT?si=y7uvsK7aQFG3-NfN0uuY7A',
  },
  {
    platform: 'Apple Music',
    icon: SiApplemusic,
    url: 'https://music.apple.com/ch/playlist/arti-hys-selected/pl.u-xlyNqM3To4LA8vE',
    color: '#d60017',
  },
  {
    platform: 'Deezer',
    icon: FaDeezer,
    url: 'https://www.deezer.com/fr/playlist/12428836523',
    color: '#a238ff',
  },
];

export const PARTNERS_LINKS = [
  {
    url: 'https://www.infomaniak.com/fr/',
    src: '/images/partners/infmaniak.svg',
  },
  {
    url: 'https://freitag.ch',
    src: '/images/partners/freitag.jpg',
    color: 'black',
  },
  {
    url: 'https://skynight.com/',
    src: '/images/partners/skynight.png',
  },
  {
    url: 'https://ramelet-fils.ch/',
    src: '/images/partners/ramelet.png',
  },
  {
    url: 'https://byfassbind.com/fr/',
    src: '/images/partners/fassbind.png',
  },
  {
    url: 'https://www.tobler-ag.com/fr/',
    src: '/images/partners/tobler.png',
  },
  {
    url: 'https://www.forum-epfl.ch/',
    src: '/images/partners/forum.svg',
  },
  { url: 'https://p-p-s.ch/', src: '/images/partners/pps.png' },
  { url: 'https://agepoly.ch/', src: '/images/partners/agep.svg' },
];
